import React from 'react';
import { BadgeCheckIcon, ClockIcon, InfoIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import type { VerificationState } from '../../types/housing';
export function VerificationBadge({
  state
}: {
  state: VerificationState;
}) {
  if (state === 'verified') {
    return <Badge tone="ok" icon={<BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-2010" data-mp="2lyo871boyw0m" />} data-id="element-2009" data-mp="2lxwpus73uusa">
        Verified listing
      </Badge>;
  }
  if (state === 'pending') {
    return <Badge tone="warn" icon={<ClockIcon className="h-3.5 w-3.5" data-id="element-2012" data-mp="1t8z8qsemr414" />} data-id="element-2011" data-mp="1ya50amwk0l92">
        Verification in progress
      </Badge>;
  }
  return <Badge tone="neutral" icon={<InfoIcon className="h-3.5 w-3.5" data-id="element-2014" data-mp="2879rj159b6wq" />} data-id="element-2013" data-mp="286rj765bl28g">
      Unverified
    </Badge>;
}